import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
`

export const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
`

export const StrengthBarContainer = styled.div`
  height: 10px;
  width: 200px;
  background: #EEEEEE;
  border: 1px solid #DDDDDD;
  border-radius: 5px;
`

export const StrengthBarFill = styled.div`
  height: 100%;
  width: ${(props) => (props.score / 4) * 100}%;
  background: ${(props) => props.theme.strengthColors[props.score - 1]};
  border-radius: 4px;
  transition: width 0.3s;
`

export const StrengthLabel = styled.p`
  color: ${(props) => props.theme.strengthColors[props.score - 1]};
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  margin: 0px;
`

export const InfoText = styled.p`
  font-size: 16px;
  text-align: center;
  margin-bottom: 0px;
  color: #FFFFFF;
`
